module.exports = __webpack_public_path__ + "img/move15.aa2af1c1.jpg";